import { ButtonBase } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'
import { Link } from 'react-router-dom'

import { useDemandAnalysisStore } from '../../contexts/demand-analysis-store-context'
import { useDemandAnalysisRoute } from '../../hooks/use-demand-analysis-route'
import { useStyles } from './styles'

interface EditableButtonProps {
  title: string
  disabled?: boolean
}

export const EditableButton = ({
  title,
  disabled = false,
}: EditableButtonProps) => {
  const classes = useStyles()
  const { makeUrl } = useDemandAnalysisRoute()

  const resetPerimeter = useDemandAnalysisStore((state) => state.resetPerimeter)

  return (
    <div className={classes.root}>
      <ButtonBase
        component={Link}
        disabled={disabled}
        onClick={resetPerimeter}
        to={makeUrl('edit')}
      >
        <EditIcon />
        {title}
      </ButtonBase>
    </div>
  )
}
